import React from 'react';
import { Layout, Menu, Breadcrumb, Avatar, Dropdown } from 'antd';
import {
  DesktopOutlined,
  UserOutlined,
  DownOutlined,
  BookOutlined,
  MoneyCollectOutlined,
  ClockCircleOutlined,
  FormOutlined
} from '@ant-design/icons'
import { withRouter, Link } from "react-router-dom";
import './index.less'
import navData from '@/routers/admin/navData'
import _ from 'lodash'
import Storage from '@/lib/storage'
import { setUser } from '@/store/actions'
import { connect } from 'react-redux'

const { Header, Content, Footer, Sider } = Layout;

@withRouter
@connect(
  state => ({
    user: state.user,
    route: state.route
  }),
  { setUser }
)
class AdminLayout extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      collapsed: false,
      breadArr: [],
      navList: [
        { name: '首页', path: '/' },
        { name: '列表', path: '/admin/home' },
        { name: '编辑', path: '/admin/edit' }
      ],
      pathname: ''
    }
  }

  get breadArr () {
    const { route } = this.props
    const navObj = _.find(navData, { path: route.pathname })
    if (navObj) return [ { name: 'BACK' }, navObj ]
    return []
  }

  onCollapse = collapsed => {
    this.setState({ collapsed });
  }

  handleClick = (path) => {
    this.props.history.push({
      pathname: path
    });
  }

  linkTo (path) {
    this.props.history.push(path)
  }

  async logout () {
    await Storage.remove('GG_PRO_USER')
    await this.props.setUser(null)
    this.props.history.push('/login')
  }

  nav = () => {
    return (
      <Menu theme="dark" selectedKeys={[ this.state.pathname ]} mode="inline">
        {
          navData.filter(item => item.show).map(item => {
            return (
              <Menu.Item key={item.path} icon={item.icon} onClick={() => this.linkTo(item.path)}>
                {item.name}
              </Menu.Item>
            )
          })
        }
        {/* <SubMenu key="sub1" icon={<UserOutlined />} title="User">
          <Menu.Item key="3">Tom</Menu.Item>
          <Menu.Item key="4">Bill</Menu.Item>
          <Menu.Item key="5">Alex</Menu.Item>
        </SubMenu> */}
      </Menu>
    )
  }

  menu = (
    <Menu>
      <Menu.Item danger>
        <a rel="noopener noreferrer" onClick={() => this.logout()}>
          登出
        </a>
      </Menu.Item>
    </Menu>
  )

  componentWillMount () {
    const localInfo = Storage.get('GG_PRO_USER')
    this.props.setUser(localInfo)

    this.props.history.listen(e => {
      console.log('1', e.pathname)
      this.setState({
        pathname: e.pathname
      })
    })
  }

  componentWillUnmount = () => {
    this.setState = (state, callback) => {
      return;
    };
  }

  render () {
    const { handleClick, state } = this
    const { navList, pathname } = state

    return (
      <div id="components-layout-demo-side">
        <Layout className="layout" style={{ minHeight: '100vh' }}>
          <Sider collapsible collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
            <div className="logo">
              Guang
            </div>
            {this.nav()}
          </Sider>
          <Layout className="admin-layout">
            <Header className="admin-layout-background" style={{ padding: 0 }}>
              <div className="header-container">
                <div>
                  <Link to="/">首页</Link>
                </div>
                <div className="right-action">
                  <Dropdown overlay={this.menu}>
                    <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
                        User
                        <DownOutlined />
                      </div>
                    </a>
                  </Dropdown>
                </div>
              </div>
            </Header>
            <Content style={{ margin: '16px 16px' }}>
              {/* <Breadcrumb style={{ margin: '16px 0' }}>
                {
                  this.breadArr.map((item, index) => {
                    return (
                      <Breadcrumb.Item key={index}>{item.name}</Breadcrumb.Item>
                    )
                  })
                }
              </Breadcrumb> */}
              <div className="site-body">
                {
                  this.props.children
                }
              </div>
            </Content>
            <Footer style={{ textAlign: 'center' }}>Ant Design ©2018 Created by Ant UED</Footer>
          </Layout>
        </Layout>
      </div>
    )
  }
}

export default AdminLayout
